import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import SEO from './components/SEO/SEO';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import ServicesOverview from './pages/ServicesOverview/ServicesOverview';
import CaseStudies from './pages/CaseStudies/CaseStudies';
import Contact from './pages/Contact/Contact';
import Privacy from './pages/Privacy/Privacy';
import Terms from './pages/Terms/Terms';

// SEO Services
import SEOServices from './pages/SEO/SEOServices';
import OnPageSEO from './pages/SEO/OnPageSEO';
import OffPageSEO from './pages/SEO/OffPageSEO';
import TechnicalSEO from './pages/SEO/TechnicalSEO';
import LinkBuilding from './pages/SEO/LinkBuilding';

// Paid Ads Services
import PaidAdsMain from './pages/PaidAds/PaidAdsMain';
import MetaAds from './pages/PaidAds/MetaAds';
import GoogleAds from './pages/PaidAds/GoogleAds';
import LinkedInAds from './pages/PaidAds/LinkedInAds';
import TikTokAds from './pages/PaidAds/TikTokAds';

// Web Development Services
import WebDevMain from './pages/WebDevelopment/WebDevMain';
import CustomWebsites from './pages/WebDevelopment/CustomWebsites';
import WordPressDevelopment from './pages/WebDevelopment/WordPressDevelopment';
import WebflowDesign from './pages/WebDevelopment/WebflowDesign';
import ShopifyDevelopment from './pages/WebDevelopment/ShopifyDevelopment';

// Email Marketing Services
import EmailMarketing from './pages/EmailMarketing/EmailMarketing';

// GoHighLevel Services
import GoHighLevel from './pages/GoHighLevel/GoHighLevel';

// Blog
import Blog from './pages/Blog/Blog';
import BlogPost from './pages/Blog/BlogPost';

// Admin
import Login from './pages/Admin/Login';
import Dashboard from './pages/Admin/Dashboard';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';

// Industry Pages
import Industries from './pages/Industries/Industries';
import Healthcare from './pages/Industries/Healthcare/Healthcare';
import RealEstate from './pages/Industries/RealEstate/RealEstate';
import Ecommerce from './pages/Industries/Ecommerce/Ecommerce';
import Legal from './pages/Industries/Legal/Legal';
import Fitness from './pages/Industries/Fitness/Fitness';
import SaaS from './pages/Industries/SaaS/SaaS';
import Dental from './pages/Industries/Dental/Dental';
import Automotive from './pages/Industries/Automotive/Automotive';
import Hospitality from './pages/Industries/Hospitality/Hospitality';
import Education from './pages/Industries/Education/Education';
import Financial from './pages/Industries/Financial/Financial';
import HomeServices from './pages/Industries/HomeServices/HomeServices';

// Industry Service Pages - SaaS
import SEOSaaS from './pages/Industries/SaaS/Services/SEOSaaS';
import PaidAdsSaaS from './pages/Industries/SaaS/Services/PaidAdsSaaS';
import WebDevSaaS from './pages/Industries/SaaS/Services/WebDevSaaS';
import EmailMarketingSaaS from './pages/Industries/SaaS/Services/EmailMarketingSaaS';
import AllInOneSaaS from './pages/Industries/SaaS/Services/AllInOneSaaS';

// Industry Service Pages - Healthcare
import SEOHealthcare from './pages/Industries/Healthcare/Services/SEOHealthcare';
import PaidAdsHealthcare from './pages/Industries/Healthcare/Services/PaidAdsHealthcare';
import WebDevHealthcare from './pages/Industries/Healthcare/Services/WebDevHealthcare';
import EmailMarketingHealthcare from './pages/Industries/Healthcare/Services/EmailMarketingHealthcare';
import AllInOneHealthcare from './pages/Industries/Healthcare/Services/AllInOneHealthcare';

// Industry Service Pages - Real Estate
import SEORealEstate from './pages/Industries/RealEstate/Services/SEORealEstate';
import PaidAdsRealEstate from './pages/Industries/RealEstate/Services/PaidAdsRealEstate';
import WebDevRealEstate from './pages/Industries/RealEstate/Services/WebDevRealEstate';
import EmailMarketingRealEstate from './pages/Industries/RealEstate/Services/EmailMarketingRealEstate';
import AllInOneRealEstate from './pages/Industries/RealEstate/Services/AllInOneRealEstate';

// Industry Service Pages - E-commerce
import SEOEcommerce from './pages/Industries/Ecommerce/Services/SEOEcommerce';
import PaidAdsEcommerce from './pages/Industries/Ecommerce/Services/PaidAdsEcommerce';
import WebDevEcommerce from './pages/Industries/Ecommerce/Services/WebDevEcommerce';
import EmailMarketingEcommerce from './pages/Industries/Ecommerce/Services/EmailMarketingEcommerce';
import AllInOneEcommerce from './pages/Industries/Ecommerce/Services/AllInOneEcommerce';

// Industry Service Pages - Legal
import SEOLegal from './pages/Industries/Legal/Services/SEOLegal';
import PaidAdsLegal from './pages/Industries/Legal/Services/PaidAdsLegal';
import WebDevLegal from './pages/Industries/Legal/Services/WebDevLegal';
import EmailMarketingLegal from './pages/Industries/Legal/Services/EmailMarketingLegal';
import AllInOneLegal from './pages/Industries/Legal/Services/AllInOneLegal';

// Industry Service Pages - Fitness
import SEOFitness from './pages/Industries/Fitness/Services/SEOFitness';
import PaidAdsFitness from './pages/Industries/Fitness/Services/PaidAdsFitness';
import WebDevFitness from './pages/Industries/Fitness/Services/WebDevFitness';
import EmailMarketingFitness from './pages/Industries/Fitness/Services/EmailMarketingFitness';
import AllInOneFitness from './pages/Industries/Fitness/Services/AllInOneFitness';

// Industry Service Pages - Dental
import SEODental from './pages/Industries/Dental/Services/SEODental';
import PaidAdsDental from './pages/Industries/Dental/Services/PaidAdsDental';
import WebDevDental from './pages/Industries/Dental/Services/WebDevDental';
import EmailMarketingDental from './pages/Industries/Dental/Services/EmailMarketingDental';
import AllInOneDental from './pages/Industries/Dental/Services/AllInOneDental';

// Industry Service Pages - Automotive
import SEOAutomotive from './pages/Industries/Automotive/Services/SEOAutomotive';
import PaidAdsAutomotive from './pages/Industries/Automotive/Services/PaidAdsAutomotive';
import WebDevAutomotive from './pages/Industries/Automotive/Services/WebDevAutomotive';
import EmailMarketingAutomotive from './pages/Industries/Automotive/Services/EmailMarketingAutomotive';
import AllInOneAutomotive from './pages/Industries/Automotive/Services/AllInOneAutomotive';

// Industry Service Pages - Hospitality
import SEOHospitality from './pages/Industries/Hospitality/Services/SEOHospitality';
import PaidAdsHospitality from './pages/Industries/Hospitality/Services/PaidAdsHospitality';
import WebDevHospitality from './pages/Industries/Hospitality/Services/WebDevHospitality';
import EmailMarketingHospitality from './pages/Industries/Hospitality/Services/EmailMarketingHospitality';
import AllInOneHospitality from './pages/Industries/Hospitality/Services/AllInOneHospitality';

// Industry Service Pages - Education
import SEOEducation from './pages/Industries/Education/Services/SEOEducation';
import PaidAdsEducation from './pages/Industries/Education/Services/PaidAdsEducation';
import WebDevEducation from './pages/Industries/Education/Services/WebDevEducation';
import EmailMarketingEducation from './pages/Industries/Education/Services/EmailMarketingEducation';
import AllInOneEducation from './pages/Industries/Education/Services/AllInOneEducation';

// Industry Service Pages - Financial
import SEOFinancial from './pages/Industries/Financial/Services/SEOFinancial';
import PaidAdsFinancial from './pages/Industries/Financial/Services/PaidAdsFinancial';
import WebDevFinancial from './pages/Industries/Financial/Services/WebDevFinancial';
import EmailMarketingFinancial from './pages/Industries/Financial/Services/EmailMarketingFinancial';
import AllInOneFinancial from './pages/Industries/Financial/Services/AllInOneFinancial';

// Industry Service Pages - Home Services
import SEOHomeServices from './pages/Industries/HomeServices/Services/SEOHomeServices';
import PaidAdsHomeServices from './pages/Industries/HomeServices/Services/PaidAdsHomeServices';
import WebDevHomeServices from './pages/Industries/HomeServices/Services/WebDevHomeServices';
import EmailMarketingHomeServices from './pages/Industries/HomeServices/Services/EmailMarketingHomeServices';
import AllInOneHomeServices from './pages/Industries/HomeServices/Services/AllInOneHomeServices';

import './styles/global.css';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <Router>
      <ScrollToTop />
      <SEO
        title="Digital Marketing Agency"
        description="Digi Network is a full-service digital marketing agency specializing in SEO, paid advertising, web development, and email marketing."
        canonical="/"
      />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services-overview" element={<ServicesOverview />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />

          {/* SEO Services Routes */}
          <Route path="/services/seo" element={<SEOServices />} />
          <Route path="/services/seo/on-page" element={<OnPageSEO />} />
          <Route path="/services/seo/off-page" element={<OffPageSEO />} />
          <Route path="/services/seo/technical-seo" element={<TechnicalSEO />} />
          <Route path="/services/seo/link-building" element={<LinkBuilding />} />

          {/* Paid Ads Routes */}
          <Route path="/services/paid-ads" element={<PaidAdsMain />} />
          <Route path="/services/paid-ads/meta" element={<MetaAds />} />
          <Route path="/services/paid-ads/google" element={<GoogleAds />} />
          <Route path="/services/paid-ads/linkedin" element={<LinkedInAds />} />
          <Route path="/services/paid-ads/tiktok" element={<TikTokAds />} />

          {/* Web Development Routes */}
          <Route path="/services/web-development" element={<WebDevMain />} />
          <Route path="/services/web-development/custom" element={<CustomWebsites />} />
          <Route path="/services/web-development/wordpress" element={<WordPressDevelopment />} />
          <Route path="/services/web-development/webflow" element={<WebflowDesign />} />
          <Route path="/services/web-development/shopify" element={<ShopifyDevelopment />} />

          {/* Email Marketing Routes */}
          <Route path="/services/email-marketing" element={<EmailMarketing />} />

          {/* GoHighLevel Routes */}
          <Route path="/services/gohighlevel" element={<GoHighLevel />} />

          {/* Blog Routes */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}>
                <Dashboard setIsAuthenticated={setIsAuthenticated} />
              </ProtectedRoute>
            }
          />

          {/* Industry Routes */}
          <Route path="/industries" element={<Industries />} />
          <Route path="/industries/healthcare" element={<Healthcare />} />
          <Route path="/industries/real-estate" element={<RealEstate />} />
          <Route path="/industries/e-commerce" element={<Ecommerce />} />
          <Route path="/industries/legal" element={<Legal />} />
          <Route path="/industries/fitness" element={<Fitness />} />
          <Route path="/industries/saas" element={<SaaS />} />
          <Route path="/industries/dental" element={<Dental />} />
          <Route path="/industries/automotive" element={<Automotive />} />
          <Route path="/industries/hospitality" element={<Hospitality />} />
          <Route path="/industries/education" element={<Education />} />
          <Route path="/industries/financial" element={<Financial />} />
          <Route path="/industries/home-services" element={<HomeServices />} />

          {/* Industry Service Routes - SaaS */}
          <Route path="/industries/saas/seo" element={<SEOSaaS />} />
          <Route path="/industries/saas/paid-ads" element={<PaidAdsSaaS />} />
          <Route path="/industries/saas/web-development" element={<WebDevSaaS />} />
          <Route path="/industries/saas/email-marketing" element={<EmailMarketingSaaS />} />
          <Route path="/industries/saas/all-in-one" element={<AllInOneSaaS />} />

          {/* Industry Service Routes - Healthcare */}
          <Route path="/industries/healthcare/seo" element={<SEOHealthcare />} />
          <Route path="/industries/healthcare/paid-ads" element={<PaidAdsHealthcare />} />
          <Route path="/industries/healthcare/web-development" element={<WebDevHealthcare />} />
          <Route path="/industries/healthcare/email-marketing" element={<EmailMarketingHealthcare />} />
          <Route path="/industries/healthcare/all-in-one" element={<AllInOneHealthcare />} />

          {/* Industry Service Routes - Real Estate */}
          <Route path="/industries/real-estate/seo" element={<SEORealEstate />} />
          <Route path="/industries/real-estate/paid-ads" element={<PaidAdsRealEstate />} />
          <Route path="/industries/real-estate/web-development" element={<WebDevRealEstate />} />
          <Route path="/industries/real-estate/email-marketing" element={<EmailMarketingRealEstate />} />
          <Route path="/industries/real-estate/all-in-one" element={<AllInOneRealEstate />} />

          {/* Industry Service Routes - E-commerce */}
          <Route path="/industries/e-commerce/seo" element={<SEOEcommerce />} />
          <Route path="/industries/e-commerce/paid-ads" element={<PaidAdsEcommerce />} />
          <Route path="/industries/e-commerce/web-development" element={<WebDevEcommerce />} />
          <Route path="/industries/e-commerce/email-marketing" element={<EmailMarketingEcommerce />} />
          <Route path="/industries/e-commerce/all-in-one" element={<AllInOneEcommerce />} />

          {/* Industry Service Routes - Legal */}
          <Route path="/industries/legal/seo" element={<SEOLegal />} />
          <Route path="/industries/legal/paid-ads" element={<PaidAdsLegal />} />
          <Route path="/industries/legal/web-development" element={<WebDevLegal />} />
          <Route path="/industries/legal/email-marketing" element={<EmailMarketingLegal />} />
          <Route path="/industries/legal/all-in-one" element={<AllInOneLegal />} />

          {/* Industry Service Routes - Fitness */}
          <Route path="/industries/fitness/seo" element={<SEOFitness />} />
          <Route path="/industries/fitness/paid-ads" element={<PaidAdsFitness />} />
          <Route path="/industries/fitness/web-development" element={<WebDevFitness />} />
          <Route path="/industries/fitness/email-marketing" element={<EmailMarketingFitness />} />
          <Route path="/industries/fitness/all-in-one" element={<AllInOneFitness />} />

          {/* Industry Service Routes - Dental */}
          <Route path="/industries/dental/seo" element={<SEODental />} />
          <Route path="/industries/dental/paid-ads" element={<PaidAdsDental />} />
          <Route path="/industries/dental/web-development" element={<WebDevDental />} />
          <Route path="/industries/dental/email-marketing" element={<EmailMarketingDental />} />
          <Route path="/industries/dental/all-in-one" element={<AllInOneDental />} />

          {/* Industry Service Routes - Automotive */}
          <Route path="/industries/automotive/seo" element={<SEOAutomotive />} />
          <Route path="/industries/automotive/paid-ads" element={<PaidAdsAutomotive />} />
          <Route path="/industries/automotive/web-development" element={<WebDevAutomotive />} />
          <Route path="/industries/automotive/email-marketing" element={<EmailMarketingAutomotive />} />
          <Route path="/industries/automotive/all-in-one" element={<AllInOneAutomotive />} />

          {/* Industry Service Routes - Hospitality */}
          <Route path="/industries/hospitality/seo" element={<SEOHospitality />} />
          <Route path="/industries/hospitality/paid-ads" element={<PaidAdsHospitality />} />
          <Route path="/industries/hospitality/web-development" element={<WebDevHospitality />} />
          <Route path="/industries/hospitality/email-marketing" element={<EmailMarketingHospitality />} />
          <Route path="/industries/hospitality/all-in-one" element={<AllInOneHospitality />} />

          {/* Industry Service Routes - Education */}
          <Route path="/industries/education/seo" element={<SEOEducation />} />
          <Route path="/industries/education/paid-ads" element={<PaidAdsEducation />} />
          <Route path="/industries/education/web-development" element={<WebDevEducation />} />
          <Route path="/industries/education/email-marketing" element={<EmailMarketingEducation />} />
          <Route path="/industries/education/all-in-one" element={<AllInOneEducation />} />

          {/* Industry Service Routes - Financial */}
          <Route path="/industries/financial/seo" element={<SEOFinancial />} />
          <Route path="/industries/financial/paid-ads" element={<PaidAdsFinancial />} />
          <Route path="/industries/financial/web-development" element={<WebDevFinancial />} />
          <Route path="/industries/financial/email-marketing" element={<EmailMarketingFinancial />} />
          <Route path="/industries/financial/all-in-one" element={<AllInOneFinancial />} />

          {/* Industry Service Routes - Home Services */}
          <Route path="/industries/home-services/seo" element={<SEOHomeServices />} />
          <Route path="/industries/home-services/paid-ads" element={<PaidAdsHomeServices />} />
          <Route path="/industries/home-services/web-development" element={<WebDevHomeServices />} />
          <Route path="/industries/home-services/email-marketing" element={<EmailMarketingHomeServices />} />
          <Route path="/industries/home-services/all-in-one" element={<AllInOneHomeServices />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
